
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsLayout from '../../components/feature/NewsLayout';

interface Article {
  id: string;
  title: string;
  content: string;
  category: string;
  excerpt: string;
  image_url: string;
  author: string;
  published_at: string;
  tags: string[];
  view_count: number;
}

export default function ZiweiPage() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchZiweiArticles();
  }, []);

  const fetchZiweiArticles = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles?category=紫微斗數&limit=50`,
        {
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
          },
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        setArticles(data.articles || []);
      }
    } catch (error) {
      console.error('獲取紫微文章失敗:', error);
      setArticles(getDefaultZiweiArticles());
    } finally {
      setLoading(false);
    }
  };

  const getDefaultZiweiArticles = () => [
    {
      id: 'ziwei1',
      title: '紫微斗數入門：十二宮位詳解與命盤解讀',
      excerpt: '紫微斗數中的十二宮位代表人生的各個層面，了解宮位含義是學習紫微斗數的基礎，助您深入理解命盤奧秘...',
      published_at: '2024-01-15T11:20:00Z',
      category: '紫微斗數',
      image_url: 'https://public.readdy.ai/ai/img_res/0ec67a76132b320864a5986c5a17abb9.jpg',
      author: '紫微大師 陳老師',
      content: '',
      tags: ['紫微斗數', '十二宮', '命理'],
      view_count: 1998
    },
    {
      id: 'ziwei2',
      title: '主星特質分析：紫微星系的奧秘與性格解讀',
      excerpt: '紫微斗數中的主星決定了個人的基本性格和命運走向，深入了解主星特質助您認識自我，發揮天賦優勢...',
      published_at: '2024-01-14T14:35:00Z',
      category: '紫微斗數',
      image_url: 'https://readdy.ai/api/search-image?query=Majestic%20purple%20star%20constellation%20in%20night%20sky%2C%20ancient%20Chinese%20emperor%20palace%20with%20golden%20decorations%2C%20mystical%20celestial%20atmosphere%20with%20traditional%20architecture&width=400&height=250&seq=ziwei2&orientation=landscape',
      author: '紫微大師 陳老師',
      content: '',
      tags: ['紫微斗數', '主星', '性格'],
      view_count: 1776
    },
    {
      id: 'ziwei3',
      title: '大限流年推算：掌握人生節奏與運勢變化',
      excerpt: '透過紫微斗數的大限流年推算，預測人生各階段的運勢變化，提前規劃未來發展，把握人生機遇...',
      published_at: '2024-01-13T16:50:00Z',
      category: '紫微斗數',
      image_url: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20fortune%20telling%20with%20circular%20star%20chart%2C%20elegant%20study%20room%20with%20ancient%20books%2C%20soft%20purple%20lighting%2C%20mystical%20scholarly%20atmosphere&width=400&height=250&seq=ziwei3&orientation=landscape',
      author: '紫微大師 陳老師',
      content: '',
      tags: ['紫微斗數', '大限', '流年'],
      view_count: 1445
    },
    {
      id: 'ziwei4',
      title: '紫微斗數婚姻宮解析：愛情與婚姻的命理密碼',
      excerpt: '通過紫微斗數婚姻宮的分析，了解個人的感情模式和婚姻運勢，為愛情選擇提供智慧指引...',
      published_at: '2024-01-12T12:25:00Z',
      category: '紫微斗數',
      image_url: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20wedding%20astrology%20with%20purple%20stars%2C%20romantic%20palace%20setting%20with%20golden%20decorations%2C%20love%20and%20marriage%20symbols%20in%20ancient%20style&width=400&height=250&seq=ziwei4&orientation=landscape',
      author: '紫微大師 陳老師',
      content: '',
      tags: ['紫微斗數', '婚姻宮', '愛情'],
      view_count: 2134
    },
    {
      id: 'ziwei5',
      title: '事業宮星曜組合：職場成功的紫微密碼',
      excerpt: '分析紫微斗數事業宮的星曜組合，了解個人的事業發展方向和成功模式，規劃職涯發展策略...',
      published_at: '2024-01-11T10:40:00Z',
      category: '紫微斗數',
      image_url: 'https://readdy.ai/api/search-image?query=Professional%20success%20symbols%20with%20purple%20stars%2C%20ancient%20Chinese%20office%20setting%20with%20scrolls%20and%20seals%2C%20career%20achievement%20atmosphere%20with%20traditional%20elements&width=400&height=250&seq=ziwei5&orientation=landscape',
      author: '紫微大師 陳老師',
      content: '',
      tags: ['紫微斗數', '事業宮', '職場'],
      view_count: 1623
    },
    {
      id: 'ziwei6',
      title: '紫微斗數化權化科化忌：四化星的運用智慧',
      excerpt: '四化星是紫微斗數的精髓，了解化權、化科、化忌的作用機制，掌握命運變化的關鍵密碼...',
      published_at: '2024-01-10T15:15:00Z',
      category: '紫微斗數',
      image_url: 'https://readdy.ai/api/search-image?query=Four%20transformation%20stars%20in%20Chinese%20astrology%2C%20mystical%20energy%20flow%20with%20purple%20and%20gold%20light%2C%20ancient%20wisdom%20symbols%20with%20cosmic%20background&width=400&height=250&seq=ziwei6&orientation=landscape',
      author: '紫微大師 陳老師',
      content: '',
      tags: ['紫微斗數', '四化', '變化'],
      view_count: 1387
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <NewsLayout 
        articles={articles}
        loading={loading}
        category="紫微斗數"
        categoryColor="bg-indigo-600"
      />
      <Footer />
    </div>
  );
}
